import type { ThemeOptions } from '@mui/material'
import { commonPaletteColors } from './palette-common'

/**
 * NOTE: Please consider adding the new colors and palette section at the end of file
 *       Preventing design team conflicts
 */
export const darkPalette: ThemeOptions['palette'] = {
  mode: 'dark',
  background: {
    default: '#0D1726',
    paper: '#0F1C2E',
  },
  text: {
    primary: '#CCE1FF',
    secondary: '#869EC0',
    tertiary: '#3E5574',
    disabled: '#576375',
  },
  line: {
    primary: '#14253E',
    secondary: '#3E5574',
    tertiary: '#6C7D93',
  },
  primary: {
    lighter: '#1C2B3F',
    light: '#93A6C0',
    main: '#E5F0FF',
    dark: '#FAFCFF',
    darker: '#FFFFFF',
    overlay: '#143666',
  },
  
  secondary: {
    lighter: '#15263F',
    light: '#4377C0',
    main: '#599EFF',
    dark: '#73ADFF',
    darker: '#EEF5FF',
    overlay: '#09101A',
  },
  tertiary: {
    lighter: '#FFF0E4',
    light: '#FFF0E4',
    main: '#E26C2B',
    dark: '#E26C2B',
    darker: '#E26C2B',
    overlay: '#FFF0E4',
    contrastText: "#ffffff",
  },
  success: {
    lighter: '#162A38',
    light: '#4C9785',
    main: '#66CCAA',
    dark: '#94DBC3',
    darker: '#F0FAF7',
    overlay: '#0D1A15',
    contrastText: '#FFFFFF',
  },
  error: {
    lighter: '#212234',
    light: '#B04D64',
    main: '#F5627B',
    dark: '#F891A3',
    darker: '#FEEFF2',
    overlay: '#1A0A0D',
  },
  warning: {
    lighter: '#212830',
    light: '#B08241',
    main: '#F5AD49',
    dark: '#F8C680',
    darker: '#FEF7ED',
    overlay: '#1A1208',
  },
  info: {
    lighter: '#15263F',
    light: '#4377C0',
    main: '#599EFF',
    dark: '#73ADFF',
    darker: '#EEF5FF',
    overlay: '#09101A',
  },
  common: commonPaletteColors,
}
